import React, { useContext } from "react"
import { LanguageContext } from "../context/language/LanguageContext"
import appConst from "../Utilities/appConst.json"

type LanguageContextType = {
  language: { id: string; text: string }
  dictionary: Record<string, string>
  getTranslation: (text_id: string) => string
  setLanguage: (language: { id: string; text: string }) => void
}

interface LupaFixUpgradeBannerProps {
  price?: number
  onUpgrade: () => void
  onDowngrade?: () => void
  isUpgraded?: boolean
}

const LupaFixUpgradeBanner = ({
  price,
  onUpgrade,
  onDowngrade,
  isUpgraded = false,
}: LupaFixUpgradeBannerProps) => {
  const languageContext = useContext(LanguageContext) as LanguageContextType

  const getUpgradeText = () => {
    const textId = isUpgraded
      ? appConst.SHORT_PATH_DOWNGRADE_TEXT
      : appConst.SHORT_PATH_UPGRADE_TEXT
    const translation = languageContext.getTranslation(textId)

    if (!translation.includes("{price}")) {
      return translation
    }

    const priceText = price !== undefined ? price.toString() : ""
    return translation.replace("{price}", priceText)
  }

  const getButtonText = () => {
    const buttonId = isUpgraded
      ? appConst.SHORT_PATH_DOWNGRADE_BUTTON
      : appConst.SHORT_PATH_UPGRADE_BUTTON

    return languageContext.getTranslation(buttonId)
  }

  const handleClick = () => {
    if (isUpgraded && onDowngrade) {
      onDowngrade()
      return
    }

    onUpgrade()
  }

  return (
    <div className="box-border blue_green_linear_gradient_background upgrade-banner rounded-md h-7 px-1 sm:px-4 text-xs sm:text-lg">
      <span>{getUpgradeText()}</span>
      <div
        onClick={handleClick}
        style={{ fontWeight: "bold", cursor: "pointer" }}
      >
        {getButtonText()}
      </div>
    </div>
  )
}

export default LupaFixUpgradeBanner
